import logo from "./redsox.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Imagined and instantly reimagined, <br></br>
          Mastered and straight away remastered. <br></br>
          <br></br> Used and worn socks available soon...
        </p>
      </header>
    </div>
  );
}

export default App;
